/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropwinnersmessagehint3Inputs */

const en_dropwinnersmessagehint3 = /** @type {(inputs: Dropwinnersmessagehint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The draw only sends winners a push notification - no automatic DM. Compose the message here (attach vouchers or QR codes as a file) and send it to all winners as Pulsify.`)
};

const de_dropwinnersmessagehint3 = /** @type {(inputs: Dropwinnersmessagehint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Ziehung schickt den Gewinnern nur eine Mitteilung – keine automatische Nachricht. Schreib die Nachricht hier (Gutscheine oder QR-Codes als Datei anhängen) und schick sie als Pulsify an alle Gewinner.`)
};

/**
* | output |
* | --- |
* | "The draw only sends winners a push notification - no automatic DM. Compose the message here (attach vouchers or QR codes as a file) and send it to all winner..." |
*
* @param {Dropwinnersmessagehint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropwinnersmessagehint3 = /** @type {((inputs?: Dropwinnersmessagehint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropwinnersmessagehint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropwinnersmessagehint3(inputs)
	return de_dropwinnersmessagehint3(inputs)
});
export { dropwinnersmessagehint3 as "dropWinnersMessageHint" }